<template>
  <modal @close="closeModal">
    <template slot="header">
      <h4 v-if="isRegister" class="modal-title">Registrar Elemento</h4>
      <h4 v-else class="modal-title">Editar Elemento</h4>
    </template>

    <form id="item_form" @submit.prevent="validate()" slot="body" class="text-center">
      <div class="md-layout">
        <div class="md-layout-item md-size-35">
          <label class="md-form-label">Familia</label>
        </div>
        <div class="md-layout-item md-size-65">
          <md-field :class="validationClass('family')">
            <label for="updatedItem.family">Familia</label>
            <md-select
              data-vv-name="businessLine"
              v-validate="modelValidations.family"
              v-model="updatedItem.family"
              name="updatedItem.family"
              id="updatedItem.family"
            >
              <md-option :value="c.id" v-for="c in families" :key="c.id" required>{{ c.name }}</md-option>
            </md-select>
            <error-indicator :valid="validField('family')"></error-indicator>
          </md-field>
        </div>
      </div>

      <div class="md-layout">
        <label class="md-layout-item md-size-35 md-form-label">Nombre de SubFamilia</label>
        <div class="md-layout-item md-size-65">
          <md-field :class="validationClass('name')">
            <md-input
              data-vv-name="name"
              v-validate="modelValidations.name"
              v-model="updatedItem.name"
              type="text"
              name="updatedItem.name"
            ></md-input>
            <span class="md-helper-text">Ingrese Nombre de Familia</span>
            <error-indicator :valid="validField('name')"></error-indicator>
          </md-field>
        </div>
      </div>

      <div class="md-layout">
        <label class="md-layout-item md-size-35 md-form-label">Código de Familia</label>
        <div class="md-layout-item md-size-65">
          <md-field :class="validationClass('code')">
            <md-input
              data-vv-name="code"
              v-validate="modelValidations.code"
              v-model="updatedItem.codename"
              type="text"
              name="updatedItem.code"
              disabled
            ></md-input>
            <span class="md-helper-text">Código de Familia</span>
            <error-indicator :valid="validField('code')"></error-indicator>
          </md-field>
        </div>
      </div>
    </form>

    <md-button class="md-info md-round" type="submit" form="item_form" slot="footer">listo</md-button>
  </modal>
</template>

<script>
import { mapState } from "vuex";
import ErrorIndicator from "@/components/Validation/ErrorIndicator";
import { watchTouchedProperties } from "@/utils";
import dataService from "../../../../services/catalog";

const modelValidations = {
  family: {
    required: true,
  },
  name: {
    required: true,
  },
  code: {
    required: false,
    max: 3,
  },
};

export default {
  components: {
    ErrorIndicator,
  },

  props: {
    editedItem: Object,
    isRegister: Boolean,
    familyId: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      updatedItem: {},
      modelValidations,
    };
  },

  methods: {
    closeModal: function () {
      this.$emit("close");
    },

    validate() {
      const sendObject = {
        original: this.editedItem,
        updated: this.updatedItem,
      };

      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          this.$emit("saved", sendObject);
        } else {
          this.$notify({
            message: "Llene Todos los campos Marcados",
            icon: "close",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "warning",
          });
        }
      });
    },

    // Miscelanius methods
    consultMetas(ruta, asign, arg1, arg2) {
      // Make query for metaDatas
      let configuret;

      if (arg2) {
        configuret = {
          id: arg1,
          extraId: arg2,
          noStore: true,
          collection: true,
        };
      } else {
        configuret = { id: arg1, noStore: true };
      }
      dataService.fetch(ruta, configuret).then((res) => {
        this[asign] = res;
      });
    },
  },

  mounted() {
    let family = this.familyId;
    family = family > 0 ? family : null;
    this.updatedItem = { ...this.editedItem };

    if (family) {
      this.updatedItem.family = family;
    }
  },

  watch: {
    ...watchTouchedProperties("updatedItem", Object.keys(modelValidations)),
  },
  computed: {
    ...mapState("catalogs", {
      families: (s) => s["services/families"],
    }),
  },
};
</script>

<style lang="scss" scoped>
.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>



// WEBPACK FOOTER //
// src/pages/Catalogs/Supplies/Existence/createSubFamily.vue